export const environment = {
  production: '_@_production_@_',
  authClientID:'_@_authClientID_@_',
  authAuthority:'_@_authAuthority_@_',
  authRedirectURI:'_@_authRedirectURI_@_',
  baseApiUrl:'_@_baseApiUrl_@_',
  apiClientID:'_@_apiClientID_@_',
  connectionString: '_@_connectionString_@_',
  version: '_@_version_@_',
  permissionToastCooldownMs: '_@_permissionToastCooldownMs_@_'
};